import React from "react";
import styles from "./index.module.css";

interface Props {
  logo?: React.ReactNode;
  children?: React.ReactNode; // Add this to handle children elements
  id?: string;
}

const Header: React.FC<Props> = ({ logo, children, id }) => (
  <mui-h-stack id={id} alignX="space-between" alignY="center" class={styles.stack}>
    {logo}
    {children}
  </mui-h-stack>
);

export default Header;
